const answerRequestPromises = new Map<string, Promise<unknown>>();
const questionsRequestPromises = new Map<string, Promise<unknown>>();

let answersLoadGeneration = 0;

export const getAnswerRequestKey = (locale: string, url: string) => `${locale}::${url}`;

export const getQuestionsRequestKey = ({
  productId,
  locale,
  characterTypeSlug,
}: {
  productId: string;
  locale?: string;
  characterTypeSlug: string;
}) => `${productId}::${locale || ''}::${characterTypeSlug}`;

export const getAnswersLoadGeneration = () => answersLoadGeneration;

export const bumpAnswersLoadGeneration = () => {
  answersLoadGeneration += 1;
};

export const getOrCreateAnswerRequest = <T>(requestKey: string, createRequest: () => Promise<T>) => {
  let requestPromise = answerRequestPromises.get(requestKey) as Promise<T> | undefined;
  if (!requestPromise) {
    requestPromise = createRequest().finally(() => {
      if (answerRequestPromises.get(requestKey) === requestPromise) {
        answerRequestPromises.delete(requestKey);
      }
    });
    answerRequestPromises.set(requestKey, requestPromise);
  }
  return requestPromise;
};

export const getOrCreateQuestionsRequest = <T>(fetchKey: string, createRequest: () => Promise<T>) => {
  let requestPromise = questionsRequestPromises.get(fetchKey) as Promise<T> | undefined;
  if (!requestPromise) {
    requestPromise = createRequest().finally(() => {
      if (questionsRequestPromises.get(fetchKey) === requestPromise) {
        questionsRequestPromises.delete(fetchKey);
      }
    });
    questionsRequestPromises.set(fetchKey, requestPromise);
  }
  return requestPromise;
};

/** Clears in-flight request caches. Useful for tests and HMR. */
export const resetProductFeedbackRequestState = () => {
  answerRequestPromises.clear();
  questionsRequestPromises.clear();
  answersLoadGeneration = 0;
};
